import "./FormEdit.scss";
import { useMemo, useState } from "react";
import {
  Col,
  Row,
  Upload,
  Icon,
  Tooltip,
  Checkbox,
  Select,
  Button
} from "antd";
import { SectionEdit } from '../'
import Logo from "../../../../layouts/commonComponent/components/Logo/Logo";
import { useTranslation } from 'react-i18next';

const FormEdit = ({ currentUser, form, refreshSection, closeSection, setForm, lang }) => {
  const [ frm, setFrm ] = useState(form)
  const [hasLogo, setHasLogo] = useState(null)
  const [position, setPosition] = useState(form.logo?.position??"RIGHT")
  const [origin, setOrigin] = useState(form.logo?.origin??"CLIENT")

  const { t } = useTranslation('forms');

  const renderLogoCliente = useMemo(() => {
    return <Logo currentUser={{clientId: currentUser.cliente.id}} />
  }, [currentUser])

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);

        reader.readAsDataURL(file); // convierte a base64
    });
  };
    const getPropsUpload = () => {
        return {
            accept: '.png,.jpg,.jpeg',
            name: 'file',
            multiple: false,
            fileList: [],
            customRequest: (options) => {
            const { file, onSuccess, onError } = options;
                setTimeout(() => {
                onSuccess("ok");
                }, 0);
            },
            onChange(info) {
                fileToBase64(info.file.originFileObj).then(base64 => {
                    let logo = form.logo
                    logo.base64 = base64
                    const f = {...form, logo}
                    setForm(f)
                })
            }
        }
    };

    const handleChangeHasLogo = (e) => {
        const hl = e.target.checked
        let logo = form.logo??{ position, origin }
        logo.hasLogo = hl
        setHasLogo(hl)
        const f = {...form, logo}
        setForm(f)
    }

    const handleChangePosition = (value) => {
        let logo = form.logo??{}
        logo.position = value
        const f = {...form, logo}
        setForm(f)
        setPosition(value)
    }

    const handleChangeOrigin = (value) => {
        let logo = form.logo??{}
        logo.origin = value
        const f = {...form, logo}
        setForm(f)
        setOrigin(value)
    }

    return (
        <div className="form-manager-edit">
            <div className="form-header">
                <Row className="header-logo">
                    <Row>
                        <Col span={3}>
                            <Checkbox disabled={!refreshSection} onChange={refreshSection && handleChangeHasLogo} defaultChecked={form.logo?.hasLogo}>
                                {t('forms.manager.logo.hasLogo')}
                            </Checkbox>
                        </Col>
                        <Col md={2} xs={3}>
                            {t('forms.manager.logo.position')}
                        </Col>
                        <Col span={5}>
                            <Select size="small" disabled={!form.logo?.hasLogo || !refreshSection} style={{width:150}} defaultValue={position} onChange={refreshSection && handleChangePosition}>
                                <Select.Option value="LEFT">{t('forms.manager.logo.left')}</Select.Option>
                                <Select.Option value="CENTER">{t('forms.manager.logo.center')}</Select.Option>
                                <Select.Option value="RIGHT">{t('forms.manager.logo.right')}</Select.Option>
                            </Select>
                        </Col>
                        <Col md={2} xs={3}>
                            {t('forms.manager.logo.logo')}
                        </Col>
                        <Col span={5}>
                            <Select size="small" disabled={!form.logo?.hasLogo || !refreshSection} style={{width:150}} defaultValue={origin} onChange={refreshSection && handleChangeOrigin}>
                                <Select.Option value="CLIENT">{t('forms.manager.logo.client')}</Select.Option>
                                { currentUser.cliente?.outsourcer === true && currentUser.cliente?.clientes && currentUser.cliente?.clientes.length > 0 &&
                                    <Select.Option value="COMPANY">{t('forms.manager.logo.company')}</Select.Option>
                                }
                                <Select.Option value="CUSTOM">{t('forms.manager.logo.custom')}</Select.Option>
                            </Select>
                        </Col>
                        { form.logo?.hasLogo && origin === "CUSTOM" &&
                            <Col md={2} xs={3}>
                                <Upload {...getPropsUpload(position)}>
                                    <Tooltip title={t('forms.manager.logo.uploadImage')}>
                                        <Button size="small" style={{width:100}}>
                                            <Icon type="file-image" size="small"/>
                                        </Button>
                                    </Tooltip>
                                </Upload>
                            </Col>
                        }
                    </Row>
                    <Row className={"has-logo-div " + (hasLogo === null ? "" : hasLogo ? "open":"closed")}>
                        { ((hasLogo === null && form.logo?.hasLogo) || hasLogo === true) &&
                        <div style={{padding:'10px 0px'}}>
                            <Row style={{padding: 20, border: '1px solid rgba(0,0,0,.1'}}>
                                <Col span={8} offset={position === "CENTER" ? 8 : position === "RIGHT" ? 16 : 0} className={"position position-"+position}>
                                    { origin === "CLIENT" ?
                                        renderLogoCliente
                                     : origin === "COMPANY" ?
                                        <div className={"div-logo-company "+position}>
                                            <div style={{width:100, border:'1px solid gray', padding:5, textAlign:'center'}}>
                                                Logo<br/>Empresa
                                            </div>
                                        </div>
                                     : origin === "CUSTOM" && form.logo?.base64 &&
                                        <div className="logo">
                                            <img src={form.logo.base64}></img>
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </div>
                        }
                    </Row>
                    {/*
                    <Row className="row-logo">
                        <DragDropContext onDragEnd={onDragEnd}>
                            {getDroppableLogo(frm,'LEFT')}
                            {getDroppableLogo(frm,'CENTER')}
                            {getDroppableLogo(frm,'RIGHT')}
                        </DragDropContext>
                    </Row>
                    */}
                </Row>
                <Row className={'form-title'}>
                    <h2 style={{fontWeight: 'bold', fontSize: '17px'}}>
                        {form?.title?.[lang] || t('forms.manager.section.namePlaceholder')}
                    </h2>
                </Row>
            </div>
            <div className="form-content">
                {frm && frm.sections && frm.sections.map((section, index) => 
                    <SectionEdit s={section}
                        refreshThisSection={refreshSection} 
                        closeSection={closeSection} 
                        sectionNro={index+1} 
                        lang={lang} 
                        mode="design"
                    />
                )}
            </div>
        </div>
    )
}
export default FormEdit;
